import { render, staticRenderFns } from "./VerifyStatement.vue?vue&type=template&id=e8a3e7cc&"
import script from "./VerifyStatement.vue?vue&type=script&lang=js&"
export * from "./VerifyStatement.vue?vue&type=script&lang=js&"
import style0 from "./VerifyStatement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports